import React, { FC } from "react";
import { WPPost } from "../../../../constants/types";
import { ListingAcf, makeAcfNullableSafe } from "../../../../constants/types/acf";
import { useTaxonomies } from "../../../../services/app-state";
import { areLocalDevFeaturesEnabled } from "../../../../utils/basic-only";

const useTaxonomyGetters = () => {
    const [{ conditions, situations, communities }] = useTaxonomies();

    const getConditionName = (conditionId: number): string => {
        return conditions.find(c => c.id === conditionId)?.name ?? "Unknown";
    };

    const getSituationName = (situationId: number): string => {
        return situations.find(s => s.id === situationId)?.name ?? "Unknown";
    };

    const getCommunityName = (communityId: number): string => {
        return communities.find(s => s.id === communityId)?.name ?? "Unknown";
    };

    return { getConditionName, getSituationName, getCommunityName };
};

export const DevModeListingTaxonomies: FC<{ listing: WPPost<ListingAcf> }> = ({ listing }) => {
    const { getConditionName, getCommunityName } = useTaxonomyGetters();

    if (!areLocalDevFeaturesEnabled()) {
        return null;
    }

    return (
        <p style={{ fontSize: 14 }}>
            <strong>Communities</strong>
            <br />
            <span>
                {makeAcfNullableSafe(listing.acf.meta.communities)
                    ?.map(getCommunityName)
                    .join(", ") ?? "--"}
            </span>
            <br />
            <strong>Conditions</strong>
            <br />
            <span>
                {makeAcfNullableSafe(listing.acf.meta.conditions_and_needs)
                    ?.map(getConditionName)
                    .join(", ") ?? "--"}
            </span>
        </p>
    );
};
